import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, ArrowLeft } from 'lucide-react';

const PreviewBanner = ({ label, livePath, liveLabel }) => (
  <div className="bg-amber-50 border-b border-amber-200" data-testid="preview-banner">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs">
      <span className="inline-flex items-center gap-1.5 font-semibold text-amber-900 uppercase tracking-[0.18em]">
        <Eye className="w-3.5 h-3.5" /> Preview · Redraft v2 · {label}
      </span>
      <span className="text-amber-800/80">Proposed copy — not live yet.</span>
      <span className="ml-auto flex items-center gap-3">
        {livePath && (
          <Link to={livePath} className="text-amber-900 underline hover:no-underline">
            Compare with live {liveLabel}
          </Link>
        )}
        <Link to="/preview/redraft-v2" className="inline-flex items-center gap-1 text-amber-900 hover:text-amber-950 font-medium">
          <ArrowLeft className="w-3 h-3" /> Preview hub
        </Link>
      </span>
    </div>
  </div>
);

export default PreviewBanner;
